import React, { useState, useEffect } from 'react';
import "./SuiviTaux.css"
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import Select from "react-select";
import CustomDatatableSuiviTaux from '../../components/CustomDatatableSuiviTaux/CustomDatatableSuiviTaux';
import { FiFilter } from "react-icons/fi"
import { ImMakeGroup } from "react-icons/im"
import { FaClipboardList } from "react-icons/fa"
import { getListInstitutionsFromCategory, getSuiviTauxCategoriesRates, getSuiviTauxInstitutionsFromCategoryAndZone, getSuiviTauxList, getSuiviTauxParams } from '../../services/http';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';


const SuiviTaux = () => {


    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);
    const navigate = useNavigate();
    const [pageNumber, setPageNumber] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [totalPage, setTotalPage] = useState(1);

    const [etablissements, setEtablissements] = useState([])
    const [catEtablissements, setCatEtablissements] = useState([])
    const [etablissementSelected, setEtablissementSelected] = useState()
    const [catEtablissementSelected, setCatEtablissementSelected] = useState()
    const [categoriesProduit, setCategoriesProduit] = useState([])
    const [zones, setZones] = useState([])
    const [categorieProduitSelected, setCategorieProduitSelected] = useState()
    const [zoneSelected, setZoneSelected] = useState()
    registerLocale('fr', fr)
    const [suiviTauxMonth, setSuiviTauxMonth] = useState()
    const [suiviTauxYear, setSuiviTauxYear] = useState()
    const [displayLoader, setDisplayLoader] = useState(true);


    const [rate, setRate] = useState()
    const [categoriesRates, setCategoriesRates] = useState([])

    const [months, setMonths] = useState([
        { "id": "01", "label": "Janvier" },
        { "id": "02", "label": "Février" },
        { "id": "03", "label": "Mars" },
        { "id": "04", "label": "Avril" },
        { "id": "05", "label": "Mai" },
        { "id": "06", "label": "Juin" },
        { "id": "07", "label": "Juillet" },
        { "id": "08", "label": "Août" },
        { "id": "09", "label": "Septembre" },
        { "id": "10", "label": "Octobre" },
        { "id": "11", "label": "Novembre" },
        { "id": "12", "label": "Décembre" },
    ])



    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Suivi", firstLevelLink: "/suivi-taux", secondLevelText: "Taux", secondLevelLink: "/suivi-taux", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("monitoring", dispatch, states);
        handleSubMenuSelection("suivi-taux", dispatch)
    }, [])

    const loadInstitutions = async () => {
        const data = {
            "zone": zoneSelected,
            "category": catEtablissementSelected
        }
        console.log(data)
        const response = await getSuiviTauxInstitutionsFromCategoryAndZone(data, states.userToken.access_token)
        if (response.response && response.response.statut !== 200) {
            console.log(response.response)
        } else {
            console.log(response.data)
            setEtablissements(response.data)
            // console.log(etablissements)
        }
    }

    useEffect(() => {
        loadInstitutions();
        console.log(etablissements)
    }, [catEtablissementSelected, zoneSelected]);

    useEffect(async () => {
        const suivi_taux_params_response = await getSuiviTauxParams(states.userToken.access_token)
        if (suivi_taux_params_response.response && suivi_taux_params_response.response.statut !== 200) {
            console.log(suivi_taux_params_response.response)
        } else {
            console.log(suivi_taux_params_response)
            setCatEtablissements(suivi_taux_params_response.data?.categorie_institution)
            setCategoriesProduit(suivi_taux_params_response.data?.categorie_produit)
            setZones(suivi_taux_params_response.data?.zone)
            console.log(categoriesProduit)
            console.log(etablissements)
        }
        // SuiTaux by default
        const actualDate = new Date();

        const etablissement = states.userInfo.institution_id ? states.userInfo.institution_id : "";
        const mois = actualDate.getMonth() + 1;
        const year = actualDate.getFullYear();
        const cat_prod = "";

        // const data = {
        //     "institution": etablissement,
        //     "mois": mois,
        //     "category_product": cat_prod,
        //     "annee": year,
        //     "zone": ""
        // }
        const data = {
            "institution": "",
            "mois": "",
            "category_product": "",
            "annee": "",
            "zone": "",
            "catInstitution": ""
        }

        console.log(data);
        const suivi_taux_list_response = await getSuiviTauxList(data, states.userToken.access_token, true, 1)
        if (suivi_taux_list_response.response && suivi_taux_list_response.response.statut !== 200) {
            console.log(suivi_taux_list_response.response.data.error)
            const errorMsg = suivi_taux_list_response.response.data.error;
            toast.error(errorMsg, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            console.log("Here we are ", suivi_taux_list_response.data)
            const perPageValue = suivi_taux_list_response?.data?.per_page
            setPerPage(perPageValue)
            const total = suivi_taux_list_response?.data?.total;
            setTotalPage(Math.ceil(total / perPageValue))
            dispatch({
                type: "SET",
                key: "suiviTauxList",
                payload: suivi_taux_list_response.data?.data,
            });
            setDisplayLoader(false);
        }


        const rates_response = await getSuiviTauxCategoriesRates(data, states.userToken.access_token, true)
        if (rates_response.response && rates_response.response.statut !== 200) {
            console.log(rates_response.response.data.error)
            const errorMsg = rates_response.response.data.error;
            toast.error(errorMsg, {
                position: toast.POSITION.TOP_RIGHT
            });
            console.log("rate error msg", errorMsg)
        } else {
            console.log("Rates key", Object.keys(rates_response.data)[0])
            console.log("Rates value", Object.values(rates_response.data)[0])

            let ratesArray = [];
            for (let i = 0; i < Object.keys(rates_response.data).length; i++) {
                console.log("i ", i)
                ratesArray.push({ category: Object.keys(rates_response.data)[i], rate: parseFloat(Object.values(rates_response.data)[i]).toFixed(2) })
            }

            console.log(ratesArray)
            setCategoriesRates(ratesArray)

        }
        // Manage Taux Calculation

        // Start Rate Calculation on Front

        const averageRate = Object.values(groupArrayOfObjects(suivi_taux_list_response.data.data, "category_product"))

        console.log("Avg Rate === ", averageRate)

        const avgArray = []
        var newData = averageRate?.map(item => (item.map(elt => ({
            name: elt.category_product,
            taux: elt.taux
        }))
        ))
        console.log(newData[0][1])
        newData?.map(item => {
            var cat_name = ""
            var arrLength = item.length
            var tauxCalc
            var tauxAdd = 0;
            item?.map(elt => {
                tauxAdd += parseFloat(elt.taux)
                cat_name = elt.name
            })
            tauxCalc = tauxAdd / arrLength
            console.log(cat_name)
            console.log(tauxCalc)
            avgArray.push({ name: cat_name, avgRate: parseFloat(tauxCalc).toFixed(2) })
        })

        console.log(newData)
        console.log(avgArray)

        setRate(avgArray)
        // End Rate Calculation on Front
        console.log(states.suiviTauxList)
        console.log(groupArrayOfObjects(states.suiviTauxList, "category_product"))
        console.log(Object.values(groupArrayOfObjects(states.suiviTauxList, "category_product")))
    }, [])

    function groupArrayOfObjects(list, key) {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };


    const handleChangeEntry = (key, e) => {
        const value = e.currentTarget.value;
        if (key == "etablissement") {
            setEtablissementSelected(value)
        }
        if (key == "cat-etablissement") {
            setCatEtablissementSelected(value)
        }
        if (key == "cat_produit") {
            setCategorieProduitSelected(value)
        }
        if (key == "zone") {
            setZoneSelected(value)
        }

    }
    const changePage = ({ selected }) => {
        let currentPage = selected + 1;
        setPageNumber(currentPage)
    }
    const handleApplyFilter = async (type) => {
        if(type == "filter"){
            setPageNumber(1)
        }
        const actualDate = new Date();
        const actualYear = actualDate.getFullYear();
        const catEtablissement = catEtablissementSelected !== undefined ? catEtablissementSelected : ""
        const etablissement = etablissementSelected !== undefined ? etablissementSelected : ""
        const zone = zoneSelected !== undefined ? zoneSelected : ""
        console.log("Here ", isNaN(suiviTauxMonth))
        const mois = (suiviTauxMonth == undefined || suiviTauxMonth == "" || isNaN(suiviTauxMonth)) ? "" : suiviTauxMonth
        const year = suiviTauxYear?.getFullYear() !== undefined ? suiviTauxYear?.getFullYear() : ""
        const cat_prod = categorieProduitSelected !== undefined ? categorieProduitSelected : ""

        const data = {
            "category_institution": catEtablissement,
            "institution": etablissement,
            "mois": mois,
            "category_product": cat_prod,
            "annee": year,
            "zone": zone
        }

        console.log("Here", data);
        const suivi_taux_list_response = await getSuiviTauxList(data, states.userToken.access_token, false, pageNumber)
        if (suivi_taux_list_response.response && suivi_taux_list_response.response.statut !== 200) {
            console.log(suivi_taux_list_response.response.data.error)
            const errorMsg = suivi_taux_list_response.response.data.error;
            toast.error(errorMsg, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            console.log("Here we are ", suivi_taux_list_response.data)
            const total = suivi_taux_list_response?.data?.total;
            const perPageValue = suivi_taux_list_response?.data?.per_page
            setTotalPage(Math.ceil(total / perPageValue))
            setPerPage(perPageValue)
            dispatch({
                type: "SET",
                key: "suiviTauxList",
                payload: suivi_taux_list_response.data?.data,
            });
            setDisplayLoader(false);
        }

        const rates_response = await getSuiviTauxCategoriesRates(data, states.userToken.access_token, false)
        if (rates_response.response && rates_response.response.statut !== 200) {
            console.log(rates_response.response.data.error)
            const errorMsg = rates_response.response.data.error;
            toast.error(errorMsg, {
                position: toast.POSITION.TOP_RIGHT
            });
            console.log("rate error msg", errorMsg)
        } else {
            console.log("Rates key", Object.keys(rates_response.data)[0])
            console.log("Rates value", Object.values(rates_response.data)[0])

            let ratesArray = [];
            for (let i = 0; i < Object.keys(rates_response.data).length; i++) {
                console.log("i ", i)
                ratesArray.push({ category: Object.keys(rates_response.data)[i], rate: parseFloat(Object.values(rates_response.data)[i]).toFixed(2) })
            }

            console.log(ratesArray)
            setCategoriesRates(ratesArray)
        }

        // Start Rate Calculation on Front
        const averageRate = Object.values(groupArrayOfObjects(suivi_taux_list_response.data?.data, "category_product"))

        console.log("Avg Rate === ", suivi_taux_list_response.data.data)

        const avgArray = []
        var newData = averageRate?.map(item => (item.map(elt => ({
            name: elt.category_product,
            taux: elt.taux
        }))
        ))
        // console.log(newData[0][1])
        newData.map(item => {
            var cat_name = ""
            var arrLength = item.length
            var tauxCalc
            var tauxAdd = 0;
            item.map(elt => {
                tauxAdd += parseFloat(elt.taux)
                cat_name = elt.name
            })
            tauxCalc = tauxAdd / arrLength
            console.log(cat_name)
            console.log(tauxCalc)
            avgArray.push({ name: cat_name, avgRate: parseFloat(tauxCalc).toFixed(2) })
        })

        console.log(newData)
        console.log(avgArray)

        setRate(avgArray)

        console.log(rate)
        // End Rate Calculation on Front
    }

    useEffect(() => {
        handleApplyFilter("no-filter")
    }, [pageNumber]);

    const tableColumns = [
        { id: "1", label: "#" },
        { id: "2", label: "Mois" },
        { id: "3", label: "Année" },
        { id: "4", label: "Produit" },
        { id: "5", label: "Etablissement" },
        { id: "6", label: "Catégorie de produit" }
    ]



    const colourStyles = {
        control: (styles) => ({ ...styles, backgroundColor: "white", height: "15px", padding: "0", innerHeight: "20px" }),
        option: (styles, { isDisabled }) => {
            return {
                ...styles,
                marginTop: "10px",
                // backgroundColor: isDisabled ? "red" : "green",
                // color: "#FFF"
                cursor: isDisabled ? "not-allowed" : "pointer"
            };
        }
    };

    function dataBox(rate, label) {
        return <div className="data-box p-2" key={label}>
            <p className=" data-box-rate">{rate} <span className="data-box-rate-percentage"> %</span></p>
            <p className=" data-box-label">{label}</p>
        </div>
    }

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    {displayLoader == false ?
                        <div className="layout-px-spacing">

                            <div className="row layout-top-spacing">
                                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                </div>
                            </div>
                            <h2 className="mb-3 text-left">Suivi des taux</h2>
                            <div className="widget widget-content widget-content-area p-3 mb-3">
                                <h5 className="text-left"> <FiFilter className="pb-1 mr-1" /> Filtres</h5>
                                <hr />
                                <div className="d-flex justify-content-around mb-2 flex-wrap">

                                    <div className="col-sm-3 col-xs-12 mb-2">
                                        <div className='truncate'>Catégorie d'établissements</div>
                                        <select onChange={(e) => handleChangeEntry("cat-etablissement", e)} className={"form-control custom-form-control basic"}>
                                            <option disabled hidden defaultValue=""> </option>
                                            <option value="">Tous</option>
                                            {catEtablissements !== [] && catEtablissements?.map((item) => (
                                                <option key={item.value} value={item.id}>{item.libelle}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-sm-2 col-xs-12 mb-2">
                                        <div>Zone</div>
                                        <select onChange={(e) => handleChangeEntry("zone", e)} className={"form-control custom-form-control basic"}>
                                            <option disabled  hidden defaultValue=""> </option>
                                            <option value="">Toutes</option>
                                            {zones !== [] && zones?.map((item) => (
                                                <option key={item.value} value={item.id}>{item.libelle}</option>
                                            ))}
                                        </select>
                                    </div>


                                    <div className="col-sm-3 col-xs-12 mb-2">
                                        <div>Etablissement</div>
                                        <select onChange={(e) => handleChangeEntry("etablissement", e)} className={"form-control custom-form-control basic "}>
                                            <option disabled  hidden defaultValue=""> </option>
                                            {etablissements.length !== 0 && <option value="">Tous</option>}
                                            {etablissements !== [] && etablissements?.map((item) => (
                                                <option key={item.value} value={item.institution_id}>{item.libelle}</option>
                                            ))}
                                        </select>
                                    </div>


                                    <div className="col-sm-3 col-xs-12 mb-2">
                                        <div className='truncate'>Catégorie produit</div>
                                        <select onChange={(e) => handleChangeEntry("cat_produit", e)} className={"form-control custom-form-control basic"}>
                                            <option disabled hidden defaultValue=""> </option>
                                            <option value="">Toutes</option>
                                            {categoriesProduit !== [] && categoriesProduit?.map((item) => (
                                                <option key={item.value} value={item.id}>{item.libelle}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-around flex-wrap">
                                    <div className="col-sm-3 col-xs-12 mb-2">
                                        <div>Mois</div>
                                        <select onChange={(e) => setSuiviTauxMonth(parseInt(e.currentTarget.value))} className={"form-control custom-form-control basic"}>
                                            <option disabled hidden defaultValue=""> </option>
                                            <option value="">Tous</option>
                                            {months && months.map(item => <option key={item.id} value={item.id}>{item.label}</option>)}


                                        </select>
                                    </div>
                                    {/* Start Month */}
                                    <div className="col-sm-4 col-xs-12 ml-1 mb-2">
                                        <div>Année</div>
                                        <DatePicker
                                            // disabled={operationType === "new" ? false : true}
                                            selected={suiviTauxYear}
                                            onChange={(date) => setSuiviTauxYear(date)}
                                            dateFormat="yyyy"
                                            locale="fr"
                                            minDate={new Date("01/01/2000")}
                                            // minDate={lastDateTransmission}
                                            maxDate={new Date()}
                                            placeholderText=""
                                            showYearPicker
                                            className={"form-control custom-form-control basic mr-1"}
                                            onChangeRaw={(e) => e.preventDefault()}
                                        />
                                    </div>

                                    {/* End Month */}
                                    <div className="col-sm-3 col-xs-12 d-flex align-items-end">

                                        <button style={{ height: "45px", width: "100%" }} className="btn btn-dark" onClick={() => handleApplyFilter("filter")}>Appliquer</button>
                                    </div>

                                </div>
                            </div>

                            <div className="widget widget-content widget-content-area p-3 mb-3">
                                <h5 className="text-left"><ImMakeGroup className="pb-1 mr-2" />Taux Moyens par catégorie</h5>
                                <hr />
                                <div className="d-flex justify-content-around flex-wrap">
                                    {categoriesRates?.length !== 0 ? categoriesRates?.map(item => dataBox(item.rate, item.category)) : <h5>Aucune donnée</h5>}

                                </div>
                            </div>

                            <div className="widget widget-content widget-content-area  pb-3 mb-3">
                                <h5 className="text-left p-3"> <FaClipboardList className="pb-1 mr-2" />Liste des taux</h5>
                                <p className="suivi-taux-total-number text-gray text-left pl-3">{states.suiviTauxList?.length <= 1 ? `${states.suiviTauxList?.length} élément` : `${states.suiviTauxList?.length} éléments`}</p>
                                {/* Start Custom Datatable */}

                                {states.suiviTauxList && states.suiviTauxList?.length != 0 ?
                                    <CustomDatatableSuiviTaux
                                        columns={tableColumns}
                                        data={states.suiviTauxList}
                                        changePage={changePage}
                                        pageCount={totalPage}
                                        pageNumber={pageNumber}
                                        perPage={perPage}
                                    /> : <h4 className="py-3">Aucun résultat</h4>}

                                {/* End Custom Datatable */}
                            </div>

                        </div> : <div style={{ marginTop: "25%" }}>
                            <Loader />
                        </div>}


                </div>
            </div>
        </div>
    )
}

export default SuiviTaux